import {SELECT_TAB} from "./TabsActionTypes";

export const selectTab = tab => (dispatch) => {
  dispatch({ type: SELECT_TAB, value: tab });
};




// WEBPACK FOOTER //
// ./src/tabs/TabsActions.js